/**
 * schoolStatus.js
 *
 * Pure helpers for deriving the display status of a selected school/site on the
 * find-schools page. Kept free of React/UI imports so it can be unit tested and
 * shared without pulling in component dependencies.
 */

/**
 * The status a selected school can be in, driving which card renders.
 * - 'active': in the network and active (green)
 * - 'inactive': in the database but not yet active (blue)
 * - 'not_found': not in the database yet (blue)
 */
export const SchoolStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NOT_FOUND: 'not_found',
};

/**
 * Derives the display status from selected site data.
 *
 * @param {object} siteData - The selected site.
 * @returns {string|null} One of SchoolStatus, or null if nothing is selected.
 */
export function getSchoolStatus(siteData) {
  if (!siteData || !siteData.type) return null;
  if (siteData.type === 'Site') {
    return siteData.isActive ? SchoolStatus.ACTIVE : SchoolStatus.INACTIVE;
  }
  if (siteData.type === 'PotentialSite') {
    return SchoolStatus.NOT_FOUND;
  }
  return null;
}
